import { useState } from 'react';
import { WebAppDeployments } from './deployments/WebAppDeployments';

// Contenedor del apartado "Deployments": pestañas por destino de despliegue.
// Solo "App web" está implementada; el resto se muestra deshabilitado.

interface DeployTarget {
  id: 'web-app' | 'mobile-app' | 'corp-website';
  label: string;
  enabled: boolean;
}

const TARGETS: DeployTarget[] = [
  { id: 'web-app', label: 'App web', enabled: true },
  { id: 'mobile-app', label: 'App móvil', enabled: false },
  { id: 'corp-website', label: 'Website corp', enabled: false },
];

export function Deployments() {
  const [active, setActive] = useState<DeployTarget['id']>('web-app');

  return (
    <div>
      <h2 style={{ margin: '0 0 16px' }}>Deployments</h2>

      <div className="tabs">
        {TARGETS.map((t) => (
          <button
            key={t.id}
            className={`tab ${active === t.id ? 'tab--active' : ''} ${t.enabled ? '' : 'tab--disabled'}`}
            disabled={!t.enabled}
            onClick={() => t.enabled && setActive(t.id)}
          >
            {t.label}
            {!t.enabled && <span className="tab-badge">próximamente</span>}
          </button>
        ))}
      </div>

      {active === 'web-app' && <WebAppDeployments />}
    </div>
  );
}
